<template>
  <div class="share-content" v-if="shareData != {}" ref="shareRef">
    <header>
      <img
        :src="
          user.avatar == ''
            ? '/static/bytx/web_broadcast_head.svg'
            : user.avatar
        "
        alt=""
      />
      <div class="header-text">
        <p>{{ user.name === "" ? user.nick_name : user.name }}</p>
        <span>邀请你一起学习</span>
      </div>
    </header>
    <div class="banner">
      <img :src="shareData.cover_img" alt="" />
    </div>
    <div class="title">
      <p class="title-text">{{ shareData.title }}</p>
      <p class="time-long">直播时间：{{ shareData.start_at }}</p>
    </div>
    <div class="line"></div>
    <div class="qr-code">
      <vue-qr
        :text="qrUrl"
        :callback="qrCallBack"
        :size="200"
        :margin="10"
        colorLight="white"
        :logoScale="0.2"
        :dotScale="0.7"
      >
      </vue-qr>
      <div>
        <p>长按识别二维码</p>
        <p>快来观看吧<van-icon name="arrow" /></p>
      </div>
    </div>
    <div class="share-footer">
      <img src="/static/bytx/share/share-icon.svg" alt="" />
      <p>博医同行</p>
    </div>
  </div>
</template>

<script>
import VueQr from "vue-qr";
import html2canvas from "html2canvas";
export default {
  name: "shareData",
  components: {
    VueQr
  },
  props: {
    id: { type: String, default: "" },
    pageType: { type: Number, default: 0 },
    shareData: { type: Object, default: {} }
  },
  data() {
    return {
      user: {},
      qrUrl: "",
      qrDownloadUrl: ""
    };
  },
  mounted() {
    let user = localStorage.getItem("user");
    this.user = JSON.parse(user);
    this.qrUrl = window.location.href;
    setTimeout(() => {
      html2canvas(this.$refs.shareRef, {
        useCORS: true,
        scale: 2,
        allowTaint: true,
        scrollY: 0,
        scrollX: 0
      }).then(canvas => {
        let url = canvas.toDataURL("image/png");
        this.$emit("getShareImg", url);
      });
    }, 1000);
  },
  methods: {
    // 二维码刷新后调用
    qrCallBack(qrUrl) {
      this.qrDownloadUrl = qrUrl;
    }
  }
};
</script>

<style scoped lang="scss">
.share-content {
  width: calc(100% - 40px);
  height: 530px;
  padding: 20px;
  background: url("/static/bytx/share/share-bg.png") no-repeat;
  background-size: 100% 100%;
  background-position: 100% 100%;
  margin-bottom: 20px;
  position: fixed;
  z-index: 0;
  top: 800px;
}
header {
  display: flex;
  align-items: center;
  img {
    width: 62px;
    height: 62px;
    margin-right: 14px;
  }
  .header-text {
    p {
      font-size: 16px;
    }
    span {
      font-size: 14px;
    }
  }
}
.banner {
  img {
    width: 100%;
    margin: 14px 0;
    border-radius: 10px;
  }
}
.title {
  .title-text {
    font-size: 18px;
    color: #222222;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .time-long {
    font-size: 13px;
    color: #666666;
  }
}
.line {
  width: 100%;
  height: 1px;
  background-color: #999;
  margin: 16px 0;
  transform: scaleY(0.2);
}
.qr-code {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 80px;
    height: 80px;
    margin-right: 14px;
  }
  p {
    font-size: 14px;
    color: #666666;
    &:last-child {
      display: flex;
      align-items: center;
      color: #10c3b5;
    }
  }
}
.share-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  img {
    width: 30px;
    margin-right: 6px;
  }
  p {
    font-size: 14px;
    color: #222222;
    font-family: PingFangSC-Regular;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shareData/index.vue